'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  margin-left: ', ';\n  min-height: 100%;\n  position: relative;\n  transition: margin-left 0.5s;\n'], ['\n  ', '\n  margin-left: ', ';\n  min-height: 100%;\n  position: relative;\n  transition: margin-left 0.5s;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledMain = _styledComponents2.default.div(_templateObject, function (props) {
  return props.contentBackgroundColor && 'background-color: ' + props.contentBackgroundColor + ';';
}, function (props) {
  return props.open ? props.sidebarWidth : '0';
});

StyledMain.displayName = 'StyledMain';

exports.default = StyledMain;
//# sourceMappingURL=StyledMain.js.map


//////////////////
// WEBPACK FOOTER
// ../app-layout/lib/StyledMain.js
// module id = 125
// module chunks = 0